import React from 'react'
import { useFirestoreDoc, useFirebaseApp } from 'reactfire'
import { Link } from 'react-router-dom'
import 'firebase/performance'
import 'firebase/firestore'

import { Text } from 'grommet'
import { Card } from 'grommet-controls'

import { sumNumbersInArray } from '../../utils/propertyComponents'
import { priceHandler, flattenObject } from '../../utils/utils'

import { accountPreferences, preferencesWeight } from '../../utils/emptyProperty'

import './Property.css'

function Property(props) {
  const { userID, docID, preferences } = props
  const firebaseApp = useFirebaseApp()
  const propertyRef = firebaseApp
    .firestore()
    .collection(userID)
    .doc(docID)

  const propertyDoc = useFirestoreDoc(propertyRef)
  const propertyObject = propertyDoc.data()

  const userPreferences = flattenObject(preferences)

  // Another Copy Paste since it doesn't matter now
  const totalAndMaxScores = Object.keys(accountPreferences).map((preference) => {
    const pref = accountPreferences[preference]
    const weight = preferencesWeight[preference]
    const arrayOfPreferences = []
    const arrayOfMaxValues = []

    Object.keys(pref).forEach(function(num) {
      const weightMultiplier =
        userPreferences[num] === 'high'
          ? 1.5
          : userPreferences[num] === 'medium'
          ? 1
          : 0.5
      if (
        typeof propertyObject[num] === 'number' &&
        propertyObject[num] > 0 &&
        propertyObject[num] <= 100
      ) {
        arrayOfPreferences.push(propertyObject[num] * (weight * weightMultiplier))
        arrayOfMaxValues.push(100 * (weight * weightMultiplier))
      } else if (num === 'associationScore') {
        // We should have these in a map and only do it once.
        if (propertyObject[num].startsWith('A++')) {
          arrayOfPreferences.push(150 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (propertyObject[num].startsWith('A+')) {
          arrayOfPreferences.push(120 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (propertyObject[num].startsWith('A')) {
          arrayOfPreferences.push(100 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (propertyObject[num].startsWith('B')) {
          arrayOfPreferences.push(50 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (propertyObject[num].startsWith('C')) {
          arrayOfPreferences.push(0 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (propertyObject[num].startsWith('D')) {
          arrayOfPreferences.push(-100 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        }
      } else if (
        num === 'rooms' &&
        propertyObject.rooms > 2 &&
        propertyObject.scoreKidsFriendly > 60
      ) {
        arrayOfPreferences.push(100 * (weight * weightMultiplier))
        arrayOfMaxValues.push(100 * (weight * weightMultiplier))
      } else if (num === 'price' && propertyObject.price < userPreferences.maxPrice) {
        const percentageOfMaxPrice = Math.round(
          (propertyObject.price / userPreferences.maxPrice) * 100
        )

        if (percentageOfMaxPrice < 70) {
          arrayOfPreferences.push(150 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (percentageOfMaxPrice < 80) {
          arrayOfPreferences.push(120 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else if (percentageOfMaxPrice < 90) {
          arrayOfPreferences.push(100 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        } else {
          arrayOfPreferences.push(90 * (weight * weightMultiplier))
          arrayOfMaxValues.push(100 * (weight * weightMultiplier))
        }
      }
    })

    const totalPreferences = sumNumbersInArray(arrayOfPreferences)
    const maxPreferences = sumNumbersInArray(arrayOfMaxValues)

    return { totalPreferences, maxPreferences }
  })

  const totalPreference = sumNumbersInArray(
    totalAndMaxScores.map((total) => total.totalPreferences)
  )
  const maxPreference = sumNumbersInArray(
    totalAndMaxScores.map((total) => total.maxPreferences)
  )

  const totalScores = Math.round((totalPreference / maxPreference) * 100)

  const price = propertyObject['price']
  const address = propertyObject['address']
  return (
    <>
      <Link
        to={{
          pathname: `/property/${address.replace(/\s+/g, '-').toLowerCase()}-${docID}`,
          state: {
            docID: docID,
            userID: userID,
            userPreferences: userPreferences
          }
        }}
        style={{
          textDecoration: 'none'
        }}
      >
        <Card
          animation={{ type: 'fadeIn', duration: 500 }}
          style={{
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.1)',
            maxWidth: 'calc(100% - 30px)',
            margin: '30px auto 0 auto',
            background:
              totalScores < 50
                ? 'linear-gradient(to bottom right, #FF4040, #FF7676)'
                : totalScores < 75
                ? 'linear-gradient(to bottom right, #FCE38A, #F38181)'
                : 'linear-gradient(to bottom right, #42E695, #3BB2B8)',
            color: 'white',
            textShadow: '1px 1px 2px rgba(0,0,0,.5)',
            padding: '10px',
            position: 'relative',
            display: 'block'
          }}
          className={totalScores > 94 && 'card'}
        >
          <Card.CardTitle pad="small" style={{ border: 'none' }}>
            <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
              {propertyObject['address']}
            </span>
          </Card.CardTitle>
          <Card.CardContent
            style={{
              display: 'grid',
              width: '100%',
              gridTemplateAreas: '"price score" "sqm-price score-price"'
            }}
          >
            <Text size="16px" style={{ gridArea: 'score', lineHeight: '30px' }}>
              <strong>Score</strong>: {totalScores}
            </Text>

            {price && (
              <>
                <Text size="16px" style={{ gridArea: 'price', lineHeight: '30px' }}>
                  <strong>$</strong>: {priceHandler(price)}
                </Text>
              </>
            )}
            {propertyObject['squareMeterPrice'] && (
              <>
                <Text size="16px" style={{ gridArea: 'sqm-price', lineHeight: '30px' }}>
                  <strong>$ SQM</strong>:{' '}
                  {priceHandler(propertyObject['squareMeterPrice'])}
                </Text>
              </>
            )}
            {price && (
              <>
                <Text size="16px" style={{ gridArea: 'score-price', lineHeight: '30px' }}>
                  <strong>$ Score</strong>:{' '}
                  {priceHandler(Math.round(price / totalScores))}
                </Text>
              </>
            )}
          </Card.CardContent>
        </Card>
      </Link>
    </>
  )
}

export default Property
